// extracted by mini-css-extract-plugin
export default {"root":"patient__ui__shared__translation-select__root","select":"patient__ui__shared__translation-select__select"};